import { render, staticRenderFns } from "./BeneficiaryTypesLegend.vue?vue&type=template&id=898a09a0&"
import script from "./BeneficiaryTypesLegend.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryTypesLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports